import styled from "styled-components/macro";
import { ParagraphProps } from "components/atoms/Paragraph/types";

export const ParagraphElement = styled.h6<ParagraphProps>`
  color: ${(props) => props?.theme?.paragraphColor};
  margin: 0;
  font-size: ${(props) => props?.size || "12px"};
`;
